module.exports = "<div ng-if=node.canFlower ng-click=expandCollapse($event) class=gz-expand-cell><md-icon ng-if=node.expanded md-svg-src=https://cdn.printos.com/images/general/material/keyboard_arrow_down.svg class=gz-expand-cell-image></md-icon><md-icon ng-if=!node.expanded md-svg-src=https://cdn.printos.com/images/general/material/keyboard_arrow_right.svg class=gz-expand-cell-image></md-icon></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/extensions/grid/expand-cell.jade
// module id = 252
// module chunks = 0